export enum DEPOSIT_ORIGIN {
  PREMIUM = 'PREMIUM',
  PARTNER = 'PARTNER',
  PREMIUM_REVOKE = 'PREMIUM_REVOKE',
}

export enum DEPOSIT_SERVICE_STATUS {
  NOT_ACTIVATED = 'NOT_ACTIVATED',
  PRE_PENDING = 'PRE_PENDING',
  PENDING = 'PENDING',
  ACTIVATED = 'ACTIVATED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}

export interface IDepositStatus {
  url: string;
  allowReusePremiumPayment: boolean;
  plusProduct: boolean;
}

export interface IDepositStatusNotActivated extends IDepositStatus {
  status: DEPOSIT_SERVICE_STATUS.NOT_ACTIVATED;
}

export interface IDepositStatusPrePending extends IDepositStatus {
  status: DEPOSIT_SERVICE_STATUS.PRE_PENDING;
  statusChanged?: boolean;
  applicationNumber: string;
  origin?: DEPOSIT_ORIGIN;
}

export interface IDepositStatusPending extends IDepositStatus {
  status: DEPOSIT_SERVICE_STATUS.PENDING;
  lastStatusUpdate: number;
  statusChanged: boolean;
  applicationNumber: string;
  origin: DEPOSIT_ORIGIN;
}

export interface IDepositStatusActivated extends IDepositStatus {
  status: DEPOSIT_SERVICE_STATUS.ACTIVATED;
  lastStatusUpdate: number;
  statusChanged: boolean;
  applicationNumber: string;
  depositValue: string;
  annualFee: string;
  monthlyFee: string;
  origin: DEPOSIT_ORIGIN;
}

export interface IDepositStatusCancelled extends IDepositStatus {
  status: DEPOSIT_SERVICE_STATUS.CANCELLED;
  lastStatusUpdate: number;
  statusChanged: boolean;
  applicationNumber: string;
  depositValue: string;
  annualFee: string;
  monthlyFee: string;
  origin: DEPOSIT_ORIGIN;
}

export interface IDepositStatusRejected extends IDepositStatus {
  status: DEPOSIT_SERVICE_STATUS.REJECTED;
  lastStatusUpdate: number;
  statusChanged: boolean;
  applicationNumber: string;
  origin: DEPOSIT_ORIGIN;
}

export type DepositState =
  | IDepositStatusNotActivated
  | IDepositStatusPrePending
  | IDepositStatusPending
  | IDepositStatusActivated
  | IDepositStatusCancelled
  | IDepositStatusRejected;
